import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/functions';

const firebaseConfig = {
	apiKey: "AIzaSyCKjb_Upzo_kf7emtUPXcOHv6vLJW5nRhM",
	authDomain: "tank-tactics-online.firebaseapp.com",
	projectId: "tank-tactics-online",
	storageBucket: "tank-tactics-online.appspot.com",
	messagingSenderId: "11762282885",
	appId: "1:11762282885:web:10b2f423b855d0da1454ec",
};
firebase.initializeApp(firebaseConfig);

const auth = firebase.auth();
const firestore = firebase.firestore();
const functions = firebase.functions();
if (window.location.hostname === "localhost") {
	auth.useEmulator("http://localhost:9099");
	firestore.useEmulator("localhost", 8080);
	functions.useEmulator("localhost", 5001);
}

auth.onAuthStateChanged(user => console.log('onAuthStateChanged: newUser:', user));

const FieldValue = firebase.firestore.FieldValue;

export {
	auth,
	firestore,
	functions,
	FieldValue,
};
